/* Rexorer cart drawer: countdown timer, subscription switch, bundle (variant) switch. */
(function () {
  if (window.__rxCartInit) return;
  window.__rxCartInit = true;

  var KEY = 'rx_cart_timer_end';
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function drawer() { return document.querySelector('cart-drawer'); }
  function attr(name, fallback) {
    var d = drawer();
    var v = d && d.getAttribute(name);
    return v === null || v === undefined || v === '' ? fallback : v;
  }
  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  /* Countdown: starts at the first look, restarts when it reaches zero. */
  function endTime() {
    var dur = (parseInt(attr('data-rx-minutes', '15'), 10) || 15) * 60000;
    var end = 0;
    try { end = parseInt(localStorage.getItem(KEY), 10) || 0; } catch (e) {}
    if (!end || end < Date.now()) {
      end = Date.now() + dur;
      try { localStorage.setItem(KEY, String(end)); } catch (e) {}
    }
    return end;
  }
  function tick() {
    var els = document.querySelectorAll('[data-rx-timer]');
    if (!els.length) return;
    var left = Math.max(0, Math.round((endTime() - Date.now()) / 1000));
    var txt = pad(Math.floor(left / 60)) + ':' + pad(left % 60);
    for (var i = 0; i < els.length; i++) {
      if (els[i].textContent !== txt) els[i].textContent = txt;
    }
  }

  /* Keep the number in the header in step with the items. */
  function syncCount() {
    var items = document.querySelector('cart-drawer-items');
    var n = items && items.getAttribute('data-rx-count');
    if (n === null || n === undefined) return;
    var outs = document.querySelectorAll('[data-rx-count-out]');
    for (var i = 0; i < outs.length; i++) {
      if (outs[i].textContent !== n) outs[i].textContent = n;
    }
  }

  function busy(on) {
    var c = document.querySelector('.rx-cart');
    if (c) { if (on) c.classList.add('rx-loading'); else c.classList.remove('rx-loading'); }
  }
  function isBusy() { return !!document.querySelector('.rx-cart.rx-loading'); }

  function post(path, body) {
    return fetch(ROOT + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok || j.status) throw new Error(j.description || j.message || attr('data-rx-error', 'Error'));
        return j;
      });
    });
  }

  function refresh() {
    return fetch(window.location.pathname + '?sections=cart-drawer,cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (s) {
        var target = document.querySelector('cart-drawer .drawer__inner');
        var src = new DOMParser().parseFromString(s['cart-drawer'], 'text/html').querySelector('.drawer__inner');
        if (target && src) target.innerHTML = src.innerHTML;
        var bubble = document.getElementById('cart-icon-bubble');
        if (bubble && s['cart-icon-bubble']) {
          var b = new DOMParser().parseFromString(s['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
          if (b) bubble.innerHTML = b.innerHTML;
        }
        syncCount();
        tick();
      });
  }

  function fail(e) {
    busy(false);
    var el = document.getElementById('CartDrawer-CartErrors');
    if (el) el.textContent = (e && e.message) || attr('data-rx-error', 'Error');
  }

  /* Subscription switch: adds or removes the selling plan on the line. */
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target.closest('[data-rx-sub]') : null;
    if (!t) return;
    e.preventDefault();
    if (isBusy()) return;
    var on = t.getAttribute('data-on') === 'true';
    busy(true);
    post('cart/change.js', {
      line: parseInt(t.getAttribute('data-line'), 10),
      quantity: parseInt(t.getAttribute('data-qty'), 10),
      selling_plan: on ? null : parseInt(t.getAttribute('data-plan'), 10)
    }).then(refresh).then(function () { busy(false); }).catch(fail);
  });

  /* Bundle switch: adds the chosen variant (keeping subscription on or off), then removes the old line. */
  document.addEventListener('change', function (e) {
    var s = e.target && e.target.closest ? e.target.closest('[data-rx-variant]') : null;
    if (!s) return;
    e.stopImmediatePropagation();
    e.stopPropagation();
    if (isBusy()) return;
    var opt = s.options[s.selectedIndex];
    var item = { id: parseInt(s.value, 10), quantity: parseInt(s.getAttribute('data-qty'), 10) };
    var plan = opt.getAttribute('data-plan');
    if (s.getAttribute('data-on') === 'true' && plan) item.selling_plan = parseInt(plan, 10);
    var key = s.getAttribute('data-key');
    busy(true);
    post('cart/add.js', { items: [item] })
      .then(function () { return post('cart/change.js', { id: key, quantity: 0 }); })
      .then(refresh)
      .then(function () { busy(false); })
      .catch(fail);
  }, true);

  setInterval(tick, 1000);
  tick();
  var d = drawer();
  if (d && window.MutationObserver) {
    new MutationObserver(function () { syncCount(); tick(); }).observe(d, { childList: true, subtree: true });
  }
})();